export const dummyPosts = [
	{
		"postTitle": { "titleText": "How to Get the Best Deals on Email Verification Services" },
		"postId": { "id": 101 },
		"postDate": { "date": "12/05/2025" },
		"postAuthor": { "authorName": "PickPlugins" },
		"commentsCount": { "count": 123 },
		"postThumbnail": { "srcUrl": "https://demo.pickplugins.com/post-grid/wp-content/uploads/sites/2/2024/07/pexels-lastly-772803.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/60b037d2fe05ceb39acb7f02dbd29bd8.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "In todays digital landscape, email marketing remains one of the most effective ways to engage customers and drive conversions..." }
	},
	{
		"postTitle": { "titleText": "10 Tips to Improve Email Deliverability Instantly" },
		"postId": { "id": 102 },
		"postDate": { "date": "10/04/2025" },
		"postAuthor": { "authorName": "PickPlugins" },
		"commentsCount": { "count": 85 },
		"postThumbnail": { "srcUrl": "https://demo.pickplugins.com/post-grid/wp-content/uploads/sites/2/2024/08/email-marketing.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/avatar2.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Struggling with low open rates? Your emails might not be landing in inboxes at all..." }
	},
	{
		"postTitle": { "titleText": "Top 5 Email Verification Tools in 2025 Compared" },
		"postId": { "id": 103 },
		"postDate": { "date": "05/03/2025" },
		"postAuthor": { "authorName": "PickPlugins" },
		"commentsCount": { "count": 67 },
		"postThumbnail": { "srcUrl": "https://demo.pickplugins.com/post-grid/wp-content/uploads/sites/2/2024/09/email-tools.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/avatar3.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Choosing the right email verification service can be overwhelming. In this post, we break down the top 5 tools..." }
	},
	{
		"postTitle": { "titleText": "Why Your Emails Are Going to Spam (And How to Fix It)" },
		"postId": { "id": 104 },
		"postDate": { "date": "22/02/2025" },
		"postAuthor": { "authorName": "PickPlugins" },
		"commentsCount": { "count": 98 },
		"postThumbnail": { "srcUrl": "https://demo.pickplugins.com/post-grid/wp-content/uploads/sites/2/2024/10/spam-folder.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/avatar4.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "If your carefully crafted emails are ending up in spam, you're not alone. Here's how to solve it..." }
	},
	{
		"postTitle": { "titleText": "Best Practices for Maintaining a Clean Email List" },
		"postId": { "id": 105 },
		"postDate": { "date": "15/01/2025" },
		"postAuthor": { "authorName": "PickPlugins" },
		"commentsCount": { "count": 56 },
		"postThumbnail": { "srcUrl": "https://demo.pickplugins.com/post-grid/wp-content/uploads/sites/2/2024/11/clean-list.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/avatar5.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Cleaning your email list regularly improves your deliverability and engagement. Here's how to do it right..." }
	},
	{
		"postTitle": { "titleText": "The Role of AI in Modern Email Marketing" },
		"postId": { "id": 106 },
		"postDate": { "date": "01/01/2025" },
		"postAuthor": { "authorName": "PickPlugins" },
		"commentsCount": { "count": 72 },
		"postThumbnail": { "srcUrl": "https://demo.pickplugins.com/post-grid/wp-content/uploads/sites/2/2024/12/ai-email.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/avatar6.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "Artificial intelligence is revolutionizing email marketing. Discover the latest trends and tools powered by AI..." }
	},
	{
		"postTitle": { "titleText": "How to Reduce Email Bounce Rates Effectively" },
		"postId": { "id": 107 },
		"postDate": { "date": "20/12/2024" },
		"postAuthor": { "authorName": "PickPlugins" },
		"commentsCount": { "count": 40 },
		"postThumbnail": { "srcUrl": "https://demo.pickplugins.com/post-grid/wp-content/uploads/sites/2/2024/12/bounce-rate.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/avatar7.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "High bounce rates can damage your sender reputation. Learn practical ways to keep your bounce rates low..." }
	},
	{
		"postTitle": { "titleText": "Email List Hygiene: Why It Matters More Than Ever" },
		"postId": { "id": 108 },
		"postDate": { "date": "05/12/2024" },
		"postAuthor": { "authorName": "PickPlugins" },
		"commentsCount": { "count": 66 },
		"postThumbnail": { "srcUrl": "https://demo.pickplugins.com/post-grid/wp-content/uploads/sites/2/2024/11/hygiene.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/avatar8.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "A clean email list isn't just best practice—it's essential. Here's why your email hygiene matters..." }
	},
	{
		"postTitle": { "titleText": "Beginner’s Guide to Email Verification APIs" },
		"postId": { "id": 109 },
		"postDate": { "date": "25/11/2024" },
		"postAuthor": { "authorName": "PickPlugins" },
		"commentsCount": { "count": 50 },
		"postThumbnail": { "srcUrl": "https://demo.pickplugins.com/post-grid/wp-content/uploads/sites/2/2024/10/api-guide.jpg" },
		"postAuthorAvatar": { "srcUrl": "https://pickplugins.com/wp-content/litespeed/avatar/avatar9.jpg?ver=1744938018" },
		"postExcerpt": { "excerptText": "If you're integrating email verification into your app or platform, this beginner's guide is the perfect place to start..." }
	}
]